import { useEffect, useState } from 'react'

/**
 * A hook that observes the DOM for changes and
 * returns the first element that matches the given selector.
 **/
export function useQuerySelector(selector: string) {
  const [element, setElement] = useState<Element | null>(null)

  useEffect(() => {
    function runQuery() {
      const foundElement = document.querySelector(selector)
      setElement(foundElement)
    }

    runQuery()

    const observer = new MutationObserver(() => {
      runQuery()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeOldValue: true,
    })

    return () => {
      observer.disconnect()
    }
  }, [selector])

  return element
}
